import(/* webpackMode: "eager" */ "/codebuild/output/src2480513968/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/page.tsx");
